import { Input, Label } from '@iwoca/orion';
import { Trans, useLingui } from '@lingui/react/macro';
import { useFormContext } from 'react-hook-form';

import styles from './DateOfBirthField.module.css';
import { TPersonalDetailsDataDE } from '../../PersonalDetailsDE';

const DateOfBirthField = () => {
  const { t } = useLingui();

  const {
    register,
    formState: { errors },
  } = useFormContext<TPersonalDetailsDataDE>();

  return (
    <div>
      <Label>
        <Trans>Date of birth</Trans>
      </Label>
      <div className={styles.dobContainer}>
        <Input
          {...register('dobDay')}
          placeholder={t`DD`}
          data-testid="dob-day"
          error={errors.dobDay?.message}
          className="fs-mask"
        />
        <Input
          {...register('dobMonth')}
          placeholder={t`MM`}
          data-testid="dob-month"
          error={errors.dobMonth?.message}
          className="fs-mask"
        />
        <Input
          {...register('dobYear')}
          placeholder={t`YYYY`}
          data-testid="dob-year"
          error={errors.dobYear?.message}
          className="fs-mask"
        />
      </div>
    </div>
  );
};

export default DateOfBirthField;
